import { defaultOptions, deserify } from '@karmaniverous/serify-deserify';

class DeserifyHelper {
    static deserify<T>(object: T) {
        return deserify(object, defaultOptions) as T;
    }
}

export default DeserifyHelper;
